import { useQuery } from "@apollo/client";
import { GET_TASK_PLANNER } from "../../graphql/queries";
import {
  PLANNER_MATCH_PROJECT_ID,
  PLANNER_CREATE_PROJECT,
  PLANNER_CREATE_TASK,
  PLANNER_LENGTH_TASK_LIST,
  PLANNER_GET_CURRENT_STATUS,
  PLANNER_VALIDATION_DATE_WORKER
} from "../actions/actionTypes";

const initialState = {
  createNewProject: {
    created_by: parseInt(localStorage.getItem("id")),
    assignee: [],
    title: "",
    description: "",
    start_date: "",
    due_date: "",
    status: "submit",
  },
  createNewTask: {
    project_id: "",
    task: "",
  },
  matchProjectID: "",
  lengthTaskList: "",
  currentStatus: [],
  dateValidationWorker: []
};



const plannerReducer = (state = initialState, action) => {

// const { error: taskError, data: taskData, loading: taskLoading } = useQuery(
//   GET_TASK_PLANNER,
//   {
//     pollInterval: 1000,
//   }
// );
  const { payload, type } = action;
  console.log(payload);
  switch (type) {
    case PLANNER_CREATE_PROJECT:
      return {
        ...state,
        createNewProject: payload,
      };
    case PLANNER_CREATE_TASK:
      return {
        ...state,
        createNewTask: payload,
      };
    case PLANNER_MATCH_PROJECT_ID:
      return {
        ...state,
        matchProjectID: payload,
      };
    case PLANNER_LENGTH_TASK_LIST:
      return {
        ...state,
        lengthTaskList: payload,
      };
    case PLANNER_GET_CURRENT_STATUS:
      return {
        ...state,
        currentStatus: payload,
      };
    case PLANNER_VALIDATION_DATE_WORKER:
      return {
        ...state,
        dateValidationWorker: payload
      }
    default:
      return state;
  }
};

export default plannerReducer;
